export const MuiCircularProgress = () => {
    return {
        defaultProps: {
            disableShrink: true
        },
        styleOverrides: {}
    };
};
